import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'

export default (props) => <RedirectTemplate location={props.location} destination="/ca/mlb-tv" />
